export default __webpack_public_path__ + "2b2e28c3307e6de2ac5bad15898f2e48.svg";